import React from 'react'
import jQuery from 'jquery'
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/datepicker.css';
import 'jquery-ui/ui/core'
import 'jquery-ui/ui/widgets/datepicker'

class DatePicker extends React.Component {

  componentDidMount() {
    const self = this

    let minDate = this.props.minDate ? this.props.minDate : null

    jQuery(this.refs.input).datepicker({
      minDate: minDate,
      yearRange: "-150:+0",
      changeMonth: true,
      changeYear: true,
      dateFormat: 'yy-mm-dd'
    })
    jQuery(this.refs.input).datepicker().on("input change", function(e) {
      self.props.change(e.target.value)
    })
  }

  componentWillUnmount() {
    jQuery(this.refs.input).datepicker('destroy');
  }

  render() {
    return <input name="visitDate" ref="input" type="text" id="datepicker" defaultValue={this.props.birthdate ? this.props.birthdate : null} />
  }
}

export default DatePicker
